// extracted by mini-css-extract-plugin
export default {"privacy":"privacy_privacy__hhaqK"};